// src/services/patientDoctors.js
import { api } from "../lib/patientApi";

function clean(params = {}) {
  return Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value !== "" && value !== null && value !== undefined)
  );
}

export const patientDoctorsApi = {
  async list(params = {}) {
    const res = await api.get("/api/v1/patients/me/doctors", { params: clean(params) });
    return res.data;
  },

  async detail(doctorId) {
    const res = await api.get(`/api/v1/patients/me/doctors/${doctorId}`);
    return res.data;
  },

  async appointments(doctorId, params = {}) {
    const res = await api.get(`/api/v1/patients/me/doctors/${doctorId}/appointments`, { params: clean(params) });
    return res.data;
  },

  async revoke(doctorId) {
    const res = await api.post(`/api/v1/patients/me/doctors/${doctorId}/revoke`);
    return res.data;
  },

  async requests() {
    const res = await api.get("/api/v1/patients/me/doctor-requests");
    return res.data;
  },

  async approveRequest(requestId) {
    const res = await api.post(`/api/v1/patients/me/doctor-requests/${requestId}/approve`);
    return res.data;
  },

  async rejectRequest(requestId) {
    const res = await api.post(`/api/v1/patients/me/doctor-requests/${requestId}/reject`);
    return res.data;
  },
};
